import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { reportType } from './ExportEOYReportAlert';

interface ExportSuccessAlertProps extends AlertDialog.AlertDialogRootProps {
    onClose?: () => void;
    exportType?: reportType;
}

const ExportSuccessAlert = ({
    onClose,
    open = false,
    exportType = 'zip',
    ...rest
}: ExportSuccessAlertProps) => {
    const isZip = exportType === 'zip';

    return (
        <AlertDialog.Root open={open} {...rest}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content className="w-[26rem] gap-y-0" onEscapeKeyDown={onClose}>
                    <AlertDialog.Header>
                        <AlertDialog.Close className="absolute right-4 top-4" onClick={onClose} />
                    </AlertDialog.Header>
                    <AlertDialog.Body className="flex !flex-row gap-4">
                        <div className="flex grow-0 flex-col">
                            <FontAwesomeIcon
                                className={'flex h-8 w-8 text-green-500'}
                                icon={faCheckCircle}
                            />
                        </div>
                        <div className="flex flex-col">
                            <p className="text-lg font-medium">
                                {isZip
                                    ? "We're generating your download!"
                                    : "We're emailing your summaries!"}
                            </p>
                            <AlertDialog.Description>
                                {isZip
                                    ? 'A link to download the zip file will be sent to your email once it is completed.'
                                    : "You'll receive an email confirmation once summaries have been sent to all supporters."}
                            </AlertDialog.Description>
                        </div>
                    </AlertDialog.Body>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const ExportSuccessAlertTrigger = AlertDialog.Trigger;

const Root = ExportSuccessAlert;
const Trigger = ExportSuccessAlertTrigger;

export {
    ExportSuccessAlert,
    ExportSuccessAlertTrigger,
    //
    Root,
    Trigger,
};
export type { ExportSuccessAlertProps };
